import { useEffect, useState } from "react";
import { PointDto, UsablePointDto } from "../service/point.interface";
import { getUsableUserPoint, getUserPoints } from "../service/point.service";

export function useUserPoints(args: { userId: string }) {
  const userId = args.userId ?? null

  const [points, setPoints] = useState<PointDto[]>([])
  const [usablePoints, setUsablePoints] = useState<UsablePointDto>({
    usableAmount: 0,
  })
  const [expiringPoints, setExpiringPoints] = useState<number>(0)

  useEffect(() => {
    fetch()
  }, [userId])


  async function fetchPoints() {
    const {items: points} = await getUserPoints(userId)
    const historiesWillExpire = points.filter(it => it.expireAt != null && it.expireAt - Date.now() < 7 * 24 * 60 * 60 * 1000 && it.leftAmount > 0);
    if (historiesWillExpire.length > 0) {
      setPoints(points)
      setExpiringPoints(historiesWillExpire.reduce((acc, it) => acc + it.leftAmount, 0))
      return;
    }
    setPoints(points)
    setExpiringPoints(0)
    return;
  }

  async function fetchUsablePoints() {
    const points = await getUsableUserPoint(userId)
    return setUsablePoints(points)
  }

  async function fetch() {
    if (!userId) {
      setPoints([])
      setUsablePoints({
        usableAmount: 0,
      })
      setExpiringPoints(0)
      return
    }

    await Promise.allSettled([
      fetchPoints(),
      fetchUsablePoints(),
    ])
  }


  return { points, usablePoints, expiringPoints, fetch }
}
